import type { ComponentRegistry } from '@json-render/react'
import { ChatbotLayout } from '../components/ChatbotLayout'
import { Sidebar } from '../components/Sidebar'
import { SessionList } from '../components/SessionList'
import { SidebarFooter } from '../components/SidebarFooter'
import { ChatPanel } from '../components/ChatPanel'
import { ChatHeader } from '../components/ChatHeader'
import { MessageList } from '../components/MessageList'
import { ChatInput } from '../components/ChatInput'
import { AdminLayout } from '../components/AdminLayout'

// Components are cast to any because json-render's ComponentRenderProps
// makes all props optional, while our components use required props.
// The Renderer always passes the correct props at runtime.
export const componentRegistry: ComponentRegistry = {
  'chatbot-layout': ChatbotLayout as any,
  'sidebar': Sidebar as any,
  'session-list': SessionList as any,
  'sidebar-footer': SidebarFooter as any,
  'chat-panel': ChatPanel as any,
  'chat-header': ChatHeader as any,
  'message-list': MessageList as any,
  'chat-input': ChatInput as any,
  'admin-layout': AdminLayout as any,
}
